import { memo, useCallback, useMemo } from 'react';
import { HighwayArea } from '@thive/fddm-types';

import { PropertiesLabel } from '@/modules/common/components/PropertiesLabel';
import { FddmServiceFactory } from '@/modules/canvas/services/Floorplan/FddmServiceFactory';
import { NumberInput } from '@/modules/common/components/inputs';
import { getCommonNumber } from '@/modules/common/helpers/commonValue';
import {
  createEmptyAreas,
  pushAreaToItsCollection,
} from '@/modules/floorplanDesign/helpers/helpers';

interface Props {
  selectedHighways: HighwayArea[];
}

function VehicleLimitComponent({ selectedHighways }: Props) {
  const fddmSvc = useMemo(() => FddmServiceFactory.getInstance().createFddmService(), []);

  const vehicleLimit = useMemo(
    () => getCommonNumber(selectedHighways.map((highway) => highway.vehicleLimit)),
    [selectedHighways],
  );

  const onChange = useCallback(
    (newValue: number) => {
      if (Number.isNaN(newValue)) return;

      // -1 means no limit ('All')
      const limit = newValue < 0 ? -1 : newValue;
      fddmSvc.setPreference('highwayArea.vehicleLimit', limit);

      const updatedAreas = createEmptyAreas();
      selectedHighways.forEach((highway) => {
        pushAreaToItsCollection(updatedAreas, { ...highway, vehicleLimit: limit });
      });
      fddmSvc.updateItems({areas: updatedAreas});
    },
    [fddmSvc, selectedHighways],
  );

  return (
    <PropertiesLabel i18nkey='interface:properties.highway.vehicles'>
      <NumberInput
        value={vehicleLimit}
        onChange={onChange}
        clearButton={{
          text: 'All',
          value: -1,
        }}
        sx={{ width: '100%', float: 'right' }}
      />
    </PropertiesLabel>
  );
}

export const VehicleLimit = memo(VehicleLimitComponent);
